import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Footer() {
  return (
    <footer className="bg-primary-900 text-background-50">
      <div className="px-6 md:px-10 py-14 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10 lg:gap-8">
          <div>
            <Link to="/" className="font-heading text-2xl font-bold tracking-tight text-background-50">
              itaobuy
            </Link>
            <p className="mt-4 text-sm text-primary-200 leading-relaxed max-w-xs">
              Your gateway to smarter spreadsheet-driven purchasing workflows. Discover tools, guides, and resources designed for efficiency and clarity.
            </p>
          </div>

          <div>
            <h4 className="text-xs uppercase tracking-widest text-primary-300 font-semibold mb-5">Categories</h4>
            <ul className="space-y-3">
              {categories.slice(0, 6).map((cat) => (
                <li key={cat.name}>
                  <a
                    href={cat.url}
                    target="_blank"
                    rel="noopener nofollow"
                    className="text-sm text-primary-200 hover:text-background-50 transition-colors duration-200 whitespace-nowrap"
                  >
                    {cat.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-xs uppercase tracking-widest text-primary-300 font-semibold mb-5">More Categories</h4>
            <ul className="space-y-3">
              {categories.slice(6).map((cat) => (
                <li key={cat.name}>
                  <a
                    href={cat.url}
                    target="_blank"
                    rel="noopener nofollow"
                    className="text-sm text-primary-200 hover:text-background-50 transition-colors duration-200 whitespace-nowrap"
                  >
                    {cat.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-xs uppercase tracking-widest text-primary-300 font-semibold mb-5">Resources</h4>
            <ul className="space-y-3">
              <li>
                <Link
                  to="/itaobuy-spreadsheet-guide"
                  className="text-sm text-primary-200 hover:text-background-50 transition-colors duration-200 whitespace-nowrap"
                >
                  Spreadsheet Guide
                </Link>
              </li>
              <li>
                <a
                  href="https://kaspreadsheet.com"
                  target="_blank"
                  rel="noopener nofollow"
                  className="text-sm text-primary-200 hover:text-background-50 transition-colors duration-200 whitespace-nowrap"
                >
                  Main Website
                </a>
              </li>
              <li>
                <Link
                  to="/"
                  className="text-sm text-primary-200 hover:text-background-50 transition-colors duration-200 whitespace-nowrap"
                >
                  Home
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-14 pt-8 border-t border-primary-700/40 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-primary-400">
            &copy; {new Date().getFullYear()} itaobuy. All external links open in new tabs.
          </p>
          <div className="flex items-center gap-4">
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="text-xs text-primary-300 hover:text-background-50 transition-colors duration-200 whitespace-nowrap"
            >
              Visit Main Site
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}